import React from "react";

import AssetReplayLogs from "./AssetReplayLogs";
import KitInventoryActivity from "./KitInventoryActivity";

export default function ActivityLog({ type = "asset", assetId, defaultTab }) {
  if (type === "kit") {
    return <KitInventoryActivity assetId={assetId} />;
  }

  return <AssetReplayLogs type={type} assetId={assetId} defaultTab={defaultTab} />;
}
